import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { FC, memo, useCallback, useEffect, useState } from "react";

import useDidUpdate from "../hooks/useDidUpdate";
import { GenericFunction, GenericObject } from "../types/generic.types";

const containerStyle = {
  height: "600px",
};

const DOHA_CENTER_COORDINATES = {
  lat: 25.279222,
  lng: 51.233224,
};

const QATAR_BOUNDS = {
  south: 24.4711180214628,
  west: 50.72110005967814,
  north: 26.21710000349892,
  east: 51.71440006361076,
};

const Location: FC<LocationProps> = ({ onLocationChange, defaultValue, readOnly = false, value = null }) => {
  const [map, setMap] = useState(null);
  const [markerLocation, setMarkerLocation] = useState<any>(null);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyCL1962HEzFzseYG8fK_pCqUmvLdi2u9qk",
  });

  const onLoad = useCallback(function callback(map) {
    const bounds = new (window as any).google.maps.LatLngBounds();
    map.fitBounds(bounds);
    setMap(map);
  }, []);

  const onUnmount = useCallback(function callback() {
    setMap(null);
  }, []);

  useDidUpdate(() => {
    onLocationChange(markerLocation);
  }, [markerLocation]);

  useEffect(() => {
    if (defaultValue) setMarkerLocation({ lat: defaultValue.toJSON().latitude, lng: defaultValue.toJSON().longitude });
  }, [defaultValue]);

  useEffect(() => {
    if (value) {
      const point = {
        lat: value.latitude,
        lng: value.longitude,
      };
      setMarkerLocation(point);
    }
  }, [value]);

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={DOHA_CENTER_COORDINATES}
      zoom={11}
      onLoad={onLoad}
      onUnmount={onUnmount}
      options={{
        restriction: {
          latLngBounds: QATAR_BOUNDS,
        },
      }}
    >
      <Marker
        position={markerLocation || DOHA_CENTER_COORDINATES}
        draggable={!readOnly}
        onDragEnd={(mapMouseEvent: any) => {
          const lat = mapMouseEvent.latLng.lat();
          const lng = mapMouseEvent.latLng.lng();
          setMarkerLocation({ lat, lng });
        }}
      />
    </GoogleMap>
  ) : (
    <></>
  );
};

interface LocationProps {
  onLocationChange: GenericFunction;
  defaultValue?: GenericObject;
  value?: GenericObject | null;
  readOnly?: boolean;
}

export default memo(Location);
